<template>
  <div class="leftBar">
    <v-drawer :direction="'left'" :width="'26%'">
      <div class="animated fadeInLeftBig dx">
        <left-card class="lefts" :bg="'border1'">
          <v-title>园区概况</v-title>
          <div class="panelContent">
            <left-top />
            <left-mid />
            <left-bot />
            <left-xs v-if="false" />
          </div>
        </left-card>
        <bar-card class="lefts lefts2" :bg="'border2'">
          <v-title>联农带农</v-title>
          <div class="panelContent">
            <left-lndn />
          </div>
        </bar-card>
        <!-- <map-nav-bar /> -->
      </div>
    </v-drawer>
  </div>
</template>

<script>
import leftTop from "./leftBar/leftTop";
import leftMid from "./leftBar/leftMid";
import leftBot from "./leftBar/leftBot";
import leftXs from "./leftBar/leftXs";
import leftLndn from "./leftBar/leftLndn";
// import mapNavBar from "../mapNavBar";
export default {
  components: {
    leftTop,
    leftMid,
    leftBot,
    leftXs,
    leftLndn
    //mapNavBar
  },
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.dx
  height 100%
.panelContent
  height calc(100% - 43px)
  color #fff
.lefts
  // height calc(83.5% - 8px)
  height calc(70% - 8px)
  margin-bottom 10px
.lefts2
  height 30%
.leftBar
  >>>.side
    bottom 8px
@media (min-height 1400px)
  .leftBar
    >>>.side
      width 24% !important
  .panelContent
    // height calc(100% - 43px)
    height calc(100% - .2rem)
@media (max-width 1280px)
  .panelContent
    height calc(100% - 25px)
</style>
